import React, { useContext } from 'react';
import MyContext from '../contextapi/MyContext';
const Header = () => {
    const context = useContext(MyContext);
    return (
        <>
            <footer class="footer-style-custom text-light text-center py-3">
                <div class="container">
                    <p>&copy; {context.copyright}</p>
                </div>
            </footer>
        </>
    );
}

export default Header;